
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestimonialCard",
  setup(props) {
    return {
      ...props
    };
  },
  props: {
    name: String,
    quote: String,
    credentials: String,
    img: String,
    link: String,
    color: String,
    flipped: Boolean
  }
});
